// API endpoints configuration

export const API_ENDPOINTS = {
  // Site endpoints
  site: {
    updateSettings: '/api/site/update-site-settings',
    createFromTemplate: '/api/site/create-site-from-template',
    publish: '/api/site/publish-site',
    updateComponent: '/api/site/update-component',
    updateTheme: '/api/site/update-theme',
    querySites: '/api/site/query-sites',
    catalogVersion: (metaSiteId: string) => `/api/site/catalog-version/${metaSiteId}`,
  },
  // Store setup endpoints
  storeSetup: {
    suggestStoreName: '/api/store/suggest-store-name',
    setupModalystProducts: '/api/store/setup-modalyst-products',
  },
  // Payment endpoints
  payment: {
    connectProvider: '/api/payment/connect-provider-account',
    paymentAggregate: (metaSiteId: string) => `/api/payment/payment-aggregate/${metaSiteId}`,
  },
} as const;

export const TIME_BUDGETS = {
  short: 10000, // 10 seconds
  medium: 20000, // 20 seconds
  long: 40000, // 40 seconds
  extended: 60000, // 60 seconds
} as const;
